import { classRooms as getClassRooms } from '../selectors/classroom';
import {
  conversation as getConversation,
  conversationTitle as getConversationTitle,
} from '../conversations/selectors';

export const isFetchingJoinUrl = (state) => state.bbb.fetchingJoinUrl;

export const description = (state, { id, context }) => {
  switch (context) {
    case 'spaces': {
      const space = getClassRooms(state)[id] || {};
      const spaceName = space.name || '';
      return `Join the session for the ${spaceName} space`;
    }
    case 'conversations': {
      const conversation = getConversation(state, id) || {};
      const title = getConversationTitle(state, id);
      return conversation.isGroup
        ? `Join the session for the ${title} group`
        : `Join a session with ${title}`;
    }
    default:
      return '';
  }
};
